import React, { createRef } from 'react'
import { object } from 'prop-types'
import TranslationContext from '../../../utils/TranslationContext'
import styles from './SubscriptionDetails.styl'
import { simpleDateParser } from '../../../utils/helpers'
import FaAngleDown from 'react-icons/lib/fa/angle-down'
import { delRequest } from '../../../utils/requestActions'
import Confirmation from '../../components/Messages/Confirmation'

export default class SubscriptionDetails extends React.Component {

	static propTypes = {
		subscription: object
	}

	static contextType = TranslationContext

	constructor(props) {
		super(props)
		this.paymentRef = createRef()
		const { subscription } = props
		const { status } = (subscription || {})
		this.state = {
			openState: status === 'pending'
		}
	}

	renderPayments(payments) {
		if (!payments.length) {
			return <li>Nenhum pagamento!</li>
		}
		return payments
			.sort((a, b) => b.createdAt - a.createdAt)
			.map((payment, index) => {
				const paymentDate = simpleDateParser(payment.createdAt)
				return (
					<li key={ index } className={ styles['payment-list-item'] }>
						<span className={ styles['payment-type'] }>
							<div>
								{ payment.type } - { payment.amount / 100 }€ - { paymentDate }
							</div>
							{ payment.status === 'pending' && payment.multibanco ?
								<div>
									<br />
									<small><strong>Referencia: </strong>{ payment.multibanco.reference }</small><br />
									<small><strong>Entidade: </strong>{ payment.multibanco.entity }</small><br />
									<small><strong>Montante: </strong>{ payment.amount / 100 }€</small>
								</div> :
								null
							}
						</span><small className={ styles[payment.status] }>{ payment.status }</small>
					</li>
				)
			})
	}

	handleClick() {
		if (window) {
			const height = getComputedStyle(this.paymentRef).height
			this.setState(prevState => ({ expanded: !prevState.expanded, height }))
		}
	}

	cancleSubscription() {
		const { subscription: { id } } = this.props
		delRequest(`/api/stripe/cancel_subscription/${ id }`)
			.then(() => {
				this.setState({ popup: false })
			})
			.catch(() => {
				this.setState({ popup: false })
			})
	}

	calculateStyle(a, b) {
		if (a && !b) {
			return { maxHeight: 'initial' }
		} else if (a && b) {
			return ({ maxHeight: getComputedStyle(this.paymentRef.current).height })
		}
		return {}
	}

	render() {
		const { subscription } = this.props
		const { openState, popup } = this.state
		const { i18n } = this.context
		const { payments, plan: { title }, startDate, endDate, status } = (subscription || {})
		return (
			<div className={ styles['subscription-list-item'] }>
				{ popup ?
					<Confirmation
						label="Pretende cancelar a sua subscrição atual?"
						confirmationAction={ this.cancleSubscription.bind(this) }
						cancelAction={ () => { this.setState({ popup: false }) } }
					/> :
					null
				}
				<div className={ styles['title-container'] } onClick={ () => { this.setState((prevstate) => ({ openState: !prevstate.openState })) } }>
					<h3>{ title }</h3>
					<small className={ styles[status] }>{ status }</small>
					<div className={ `${ styles['down-arrow'] } ${ openState ? styles['rotate'] : '' }` }><FaAngleDown /></div>
				</div>
				<div className={ styles['details-container'] }>
					<div>
						{ startDate ? <small><strong>{ i18n`subscription_start_date_label` }</strong> { simpleDateParser(startDate) }</small> : null }
						{ endDate ? <small><br /><strong>{ i18n`subscription_end_date_label` }</strong>{ simpleDateParser(endDate) }</small> : null }
					</div>
					{ status !== 'expired' ? <div className={ styles['submitButton'] }>
						<button onClick={ () => { this.setState({ popup: true }) } }>Cancelar</button>
					</div> : null }
				</div>
				<div className={ `${ styles['payment-list'] } ${ openState ? styles['is-active'] : styles['is-hidden'] }` } style={ this.calculateStyle(openState, this.paymentRef.current) }>
					<ul ref={ this.paymentRef }>
						{ this.renderPayments(payments) }
					</ul>
				</div>
			</div >
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/SubscriptionDetails/SubscriptionDetails.js